import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {FormGridSectionItem, FormGridSectionTitle} from '@/components/ui/form-atoms/FormAtoms'
import {StyledFormSection} from './style'

export const FormSectionLoader = () => {
    return (
        <StyledFormSection>
            <FormGridSectionItem>
                <FormGridSectionTitle>
                    <Skeleton width="100%" height={24} />
                    <Skeleton width="80%" height={18} />
                </FormGridSectionTitle>
            </FormGridSectionItem>
            <FormGridSectionItem>
                <Skeleton height={32} width="100%" />
                <Skeleton height={32} width="80%" />
                <Skeleton height={32} width="60%" />
            </FormGridSectionItem>
        </StyledFormSection>
    )
}
